<template>
  <v-container>
    <!-- <v-row
      justify="center"
      v-if="
        dataVersion &&
          dataVersion.profitVersion &&
          (dataVersion.profitVersion.status == 'NEW' ||
            dataVersion.profitVersion.status == 'PROPOSAL')
      "
    >
      <v-col cols="12" xl="11" lg="11" md="11">
        <v-autocomplete
          v-model="version"
          :items="versions"
          label="Selecciona versión"
          outlined
          clearable
          background-color="white"
          dense
        ></v-autocomplete>
      </v-col>
    </v-row> -->
    <v-row justify="center" class="mt-0">
      <v-col cols="12" xl="11" lg="11" md="11" class="pt-0">
        <v-card elevation="3" class="rounded-lg d-flex" height="690">
          <v-card-text
            class="
              overflow-y-auto
              text-caption
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
          >
            <v-container v-if="dataVersion">
              <v-row class="text-center">
                <v-col>
                  <span class="font-weight-bold black--text">
                    {{ dataVersion.profitVersion.protocolName }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <span class="font-weight-bold">Objetivo</span>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <span v-if="currentVersion">
                        <div v-if="currentVersion.targets && currentVersion.targets.length > 0">
                          {{ getDescriptionText() }}
                        </div>
                        <div v-else>
                          {{ currentVersion.target }}
                        </div>
                      </span>
                      <span v-else>---</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <span v-if="currentVersion"
                        >{{
                          parseFloat(currentVersion.surface).toFixed(1)
                        }}
                        Ha</span
                      >
                      <span v-else>-- Ha</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <span v-if="currentVersion"
                        >{{ currentVersion.totalDose }} dósis</span
                      >
                      <span v-else>-- dósis</span>
                      <v-tooltip top color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            class="ml-1"
                          >
                            mdi-information
                          </v-icon>
                        </template>
                        <span>Dósis aplicadas en rentabilización</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="text-end">
                  <v-row>
                    <v-col>
                      <span v-if="currentVersion">
                        {{ currentVersion.cycleLength }} Mes
                      </span>
                      <span v-else>-- Mes</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentVersion">
                    <v-col class="pb-0">
                      <span class="primary--text"
                        >${{ currentVersion.price }}/Ha</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <span class="primary--text">{{
                        getStatus(dataVersion.profitVersion.status)
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="ma-0 pa-0">
                  <v-expansion-panels flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-3">
                        Zonas(s) de muestreo
                      </v-expansion-panel-header>
                      <v-expansion-panel-content
                        v-if="currentVersion"
                        class="ma-0 pa-0"
                      >
                        <div
                          v-for="(sample, index) of currentVersion.samples"
                          :key="index"
                        >
                          <v-row class="ma-0 pa-0">
                            <v-col
                              cols="6"
                              class="ma-0 pa-0 font-weight-bold"
                              v-if="sample.name.length <= 16"
                            >
                              {{ sample.name }}
                            </v-col>
                            <v-col
                              cols="6"
                              class="ma-0 pa-0 font-weight-bold"
                              v-else
                            >
                              {{ truncateString(sample.name, 13) }}
                            </v-col>
                            <v-col cols="6" class="text-end ma-0 pa-0">
                              <span>
                                {{ getCrop(sample.crop) }} - {{ sample.date }}
                              </span>
                            </v-col>
                          </v-row>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row v-if="currentVersion">
                <v-col v-for="(item, index) of schdule" :key="index" cols="12">
                  <DosesItem :tracing="item" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//VUEX
import { mapState, mapMutations, mapActions } from "vuex";
//COMPONENTS
import DosesItem from "@/components/territory/DosesItem";
export default {
  components: {
    DosesItem,
  },
  data: () => ({
    version: null,
    versions: [],
    dataVersion: null,
    currentVersion: null,
    schdule: [],
  }),
  computed: {
    ...mapState("areasList", ["crops"]),
    ...mapState("profit", ["action"]),
  },
  async mounted() {
    await this.init();
  },
  methods: {
    ...mapActions("profit", ["getProfitVersion", "acceptProfit"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("profit", ["SET_ACTION"]),
    async init() {
      try {
        let response = await this.getProfitVersion({
          profitId: this.$route.params.profitId,
        });
        if (response) {
          if (!response.error) {
            //load data in UI
            for (let i = 0; i < response.profits.length; i++) {
              this.versions.push(i + 1);
            }
            this.dataVersion = response;
            if (
              response.profitVersion.status != "NEW" &&
              response.profitVersion.status != "PROPOSAL"
            ) {
              this.SET_APPBAR_OPTIONS({
                leftButton: "back-arrow",
                funcLeftButton: this.goBack,
                rightButton: "profit_detail",
              });
              this.version = "0";
            } else {
              let user = JSON.parse(localStorage.getItem("user"));
              if (user.role == "ORG_USER") {
                this.SET_APPBAR_OPTIONS({
                  leftButton: "back-arrow",
                  funcLeftButton: this.goBack,
                  rightButton: "profit_detail",
                });
              } else {
                this.SET_APPBAR_OPTIONS({
                  leftButton: "back-arrow",
                  funcLeftButton: this.goBack,
                  rightButton: "profit_detail_acceptable",
                });
              }

              this.version = this.versions[0];
            }
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text:
                "Algo salio mal al cargar la rentabilización !!, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text:
              "Algo salio mal al cargar la rentabilización !!, intente de nuevo",
            timeout: 4000,
          });
        }
      } catch (e) {
        this.SET_APPBAR_OPTIONS({
          leftButton: "back-arrow",
          funcLeftButton: this.goBack,
          rightButton: "profit_detail_acceptable",
        });
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text:
            "Algo salio mal al cargar la rentabilización !!, intente de nuevo",
          timeout: 4000,
        });
      }
    },
    goBack() {
      this.$router.back();
    },
    getFormatted(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    getStatus(value) {
      let status = {
        NEW: "Nuevo",
        PROPOSAL: "Presentando al cliente",
        ACCEPTED: "Aceptada por el cliente",
        FINISHED: "Finalizada",
      };
      return status[value];
    },
    getCrop(value) {
      try {
        return this.crops[value];
      } catch (e) {
        console.log(e);
        return "Sin cultivo";
      }
    },
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      if (str.length <= num) {
        return str;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return str.slice(0, num) + "...";
    },
    arraysEqual(arr1, arr2) {
      // Check if arrays have the same elements
      if (arr1.length !== arr2.length) return false;
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      }
      return true;
    },
    arrayContainsExactCombination(arr, combination) {
      const arrSet = new Set(arr);
      const combSet = new Set(combination);
      return this.arraysEqual([...arrSet], [...combSet]);
    },
    getDescriptionText() {
      const combination1 = ["CSPF"];
      const combination2 = ["PPS"];
      const combination3 = ["CPN"];
      const combination4 = ["CSPF", "PPS"];
      const combination5 = ["CSPF", "PPS", "CPN"];
      const combination6 = ["CSPF", "CPN"];
      const combination7 = ["PPS", "CPN"];

      if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination1
        )
      ) {
        return "Disminuir concentraciones de hongos patógenos de suelo mediante el uso de microorganismos benéficos.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination2
        )
      ) {
        return "Solubilización de Fósforo y Potasio.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination3
        )
      ) {
        return "Disminuir concentraciones de nematodos fitopatógenos mediante el uso de microorganismos benéficos.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination4
        )
      ) {
        return "Disminuir concentraciones de hongos patógenos mediante el uso de microorganismos benéficos. Solubilización de Fósforo y Potasio.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination5
        )
      ) {
        return "Disminuir concentraciones de hongos patógenos de suelo y nematodos fitopatógenos mediante el uso de microorganismos benéficos. Solubilización de Fósforo y Potasio.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination6
        )
      ) {
        return "Disminuir concentraciones de hongos patógenos de suelo y nematodos fitopatógenos mediante el uso de microorganismos benéficos.";
      } else if (
        this.arrayContainsExactCombination(
          this.currentVersion.targets,
          combination7
        )
      ) {
        return "Disminuir concentraciones de nematodos fitopatógenos mediante el uso de microorganismos benéficos. Solubilización de Fósforo y Potasio.";
      }
    },
  },
  watch: {
    async version(value) {
      try {
        if (value) {
          if (
            this.dataVersion.profitVersion.status != "NEW" &&
            this.dataVersion.profitVersion.status != "PROPOSAL"
          ) {
            this.currentVersion = this.dataVersion.profit;
          } else {
            this.currentVersion = this.dataVersion.profits[Number(value) - 1];
          }

          if (this.currentVersion) {
            let list = [];
            for (
              let index = 0;
              index < this.currentVersion.cycleLength + 1;
              index++
            ) {
              //set base length of samples in current profit
              let sampleDoses = {
                baseTotal: this.currentVersion.analysis.length,
                analysis: null,
              };
              //set analysis type
              let type = "";
              if (index === 0) {
                type = "INITIAL";
              } else {
                type = "MONITORING";
              }
              sampleDoses.type = type;
              //set analysis info

              //if analysis is ready
              if (this.currentVersion.analysis[index]) {
                sampleDoses.analysis = this.currentVersion.analysis[index];
              } else {
                let fakeAnalysis = {
                  analysis: [],
                };
                for (let i = 0; i < this.currentVersion.analysis.length; i++) {
                  fakeAnalysis.analysis.push({
                    date: "--/--/---- hrs.",
                    folioAnalysis: "--",
                    name: "--",
                  });
                }
                sampleDoses.analysis = fakeAnalysis;
              }

              //set application by week and month
              let applicationMonth = [];
              if (
                this.currentVersion.products &&
                this.currentVersion.products.length > 0
              ) {
                if (this.currentVersion.products[index]) {
                  this.currentVersion.products[index].forEach(
                    (element, indexWeek) => {
                      let data = {
                        week: indexWeek + 1,
                        month: index + 1,
                      };
                      let doseApplicationByWeek = [];
                      element.forEach((applicationModel) => {
                        let dose = {
                          dose: applicationModel.dose,
                          strain: applicationModel.strain,
                        };
                        doseApplicationByWeek.push(dose);
                      });
                      data.doses = doseApplicationByWeek;
                      applicationMonth.push(data);
                    }
                  );
                }
              }
              sampleDoses.applications = applicationMonth;
              list.push(sampleDoses);
            }
            this.schdule = list;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async action(value) {
      if (value === "pdf") {
        if (this.currentVersion) {
          if (this.currentVersion.urlPdf.length > 0) {
            var a = document.createElement("a");
            a.href = this.currentVersion.urlPdf;
            let fileName = this.currentVersion.urlPdf.split("/").pop();
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(this.currentVersion.urlPdf);
            a.remove();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "info",
              text: "Versión en PDF no disponible, intente en otro momento !!",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "info",
            text: "No se puede descargar el PDF",
            timeout: 4000,
          });
        }
        this.SET_ACTION(null);
      } else if (value === "accepted") {
        try {
          this.SET_LOADER(true);
          let request = {
            profitId: this.currentVersion._id,
            profitVersionId: this.$route.params.profitId,
          };
          let response = await this.acceptProfit(request);
          if (response) {
            if (!response.error) {
              await this.init();
              this.SET_LOADER(false);
            } else {
              console.log(response.message);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text:
                  "Algo salio mal al aceptar rentabilización, intente en otro momento !!",
                timeout: 4000,
              });
              this.SET_LOADER(false);
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text:
                "Algo salio mal al aceptar rentabilización, intente en otro momento !!",
              timeout: 4000,
            });
            this.SET_LOADER(false);
          }
        } catch (e) {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text:
              "Algo salio mal al aceptar rentabilización, intente en otro momento !!",
            timeout: 4000,
          });
          this.SET_LOADER(false);
        }
        this.SET_ACTION(null);
      }
    },
  },
};
</script>
